import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNotification, fetchNotification } from "@/slices/notificationSlice/NotificationSlice";

function UpdateNotification({ data, onClose }) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    id: "",
    title: "",
    body: "",
    status: false,
    is_read: false,
  });

  // ✅ Prefill data
  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || "",
        title: data.title || "",
        body: data.body || "",
        status: data.status || false,
        is_read: data.is_read || false,
      });
    }
  }, [data]);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const { id, title, body, is_read, status } = formData;

  const updatedData = {
    smsList: [
      {
        id,
        title,
        body,
        is_read,
        status,
      },
    ],
  };

  const resp = await dispatch(updateNotification(updatedData));

  if (!resp.error) {
    dispatch(fetchNotification({ page: 1 }));
    onClose(); // close modal
  }
};

  return (
    <div className="p-2 mx-auto md:min-w-[500px] bg-white rounded-lg">
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Title */}
        <div>
          <label className="block text-gray-700">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-lg"
            required
          />
        </div>

        {/* Body */}
        <div>
          <label className="block text-gray-700">Body</label>
          <textarea
            name="body"
            value={formData.body}
            onChange={handleChange}
            rows="3"
            className="w-full px-3 py-2 border rounded-lg resize-none"
            required
          />
        </div>

        {/* Status Checkbox */}
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            name="status"
            checked={formData.status}
            onChange={handleChange}
            className="w-4 h-4"
          />
          <label>Status</label>
        </div>

        {/* Is Read Checkbox */}
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            name="is_read"
            checked={formData.is_read}
            onChange={handleChange}
            className="w-4 h-4"
          />
          <label>Is Read</label>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-[var(--mainCol)] text-white py-2 rounded-lg"
        >
          Update Notification
        </button>
      </form>
    </div>
  );
}

export default UpdateNotification;